import { memo } from "react";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import PropTypes from "prop-types";
import "./FavoriteBadge.scss";

const FavoriteBadge = ({ showLabel = true }) => {
	return (
		<div className="favorite-badge" data-testid="favorite-badge">
			<img
				src="https://res.cloudinary.com/perfectstay/image/upload/v1476467741/icons/icon-coeur-black.svg"
				alt={""}
				width={12}
				height={12}
			/>

			{showLabel && (
				<Typography variant={TYPOGRAPHY_VARIANTS.SMALL} isBold component="p">
					<FormattedMessage id="product.isFavorite" />
				</Typography>
			)}
		</div>
	);
};

FavoriteBadge.propTypes = {
	showLabel: PropTypes.bool,
};

export default memo(FavoriteBadge);
